import {
  MainContent,
  SubTitle,
  Text,
  TextAnnotation,
  BoldText,
  Img,
} from 'src/components/contents/direction/DirectionPage';
import Direction01 from 'src/assets/images/direction/tmark/tmark_direction_mobile_01.svg';
import Direction02 from 'src/assets/images/direction/tmark/tmark_direction_mobile_02.svg';
import Direction03 from 'src/assets/images/direction/tmark/tmark_direction_mobile_03.svg';
import Direction04 from 'src/assets/images/direction/tmark/tmark_direction_mobile_04.svg';
import Direction05 from 'src/assets/images/direction/tmark/tmark_direction_mobile_05.svg';
import Direction06 from 'src/assets/images/direction/tmark/tmark_direction_mobile_06.svg';
import Direction07 from 'src/assets/images/direction/tmark/tmark_direction_mobile_07.svg';
import { Link } from 'react-router-dom';

interface Iprops {
  color?: string;
}

/**
 * 專利操作說明行動版。
 */
const TmarkDirectionMobile: React.FC<Iprops> = ({ color }) => {
  return (
    <MainContent>
      <p>商標權證查詢提供商標權之權利狀態與證書影像查詢；以下是其操作說明。</p>
      <SubTitle>查詢商標權證：</SubTitle>
      <Text>
        1. 進入
        <Link to={process.env.PUBLIC_URL === '' ? "/" : process.env.PUBLIC_URL} style={{ color: color }}>
          權證查詢系統
        </Link>
        。
      </Text>
      <Text>2. 點擊「商標權證」。</Text>
      <Img src={Direction01} />
      <Text>3. 您可利用搜尋框輸入查詢條件，按下「搜尋」按鈕後，即可查詢出相關搜尋結果。</Text>
      <Img src={Direction02} />
      <Text>
        4. 除了上圖中顯示之搜尋條件，您可點擊下拉選單，選擇其他條件。
        <br />
        包括：商標註冊號數、申請案號，以及商標權人中文名稱、商標權人英文名稱、代理人名稱。
      </Text>
      <Img src={Direction03} />
      <Img src={Direction04} />
      <SubTitle>查詢使用情境：</SubTitle>
      <BoldText>查詢您的註冊商標使用權限是否已經快到期了。</BoldText>
      <Text>1. 您可點擊下拉選單，選擇商標權人中文或英文名稱，並輸入姓名。</Text>
      <Text>2. 在「專用期限」輸入日期區間。</Text>
      <Text>3. 按下「搜尋」按鈕後，即可查詢出相關搜尋結果。</Text>
      <Img src={Direction05} />
      <SubTitle>查詢結果：</SubTitle>
      <p>若要檢視單一資料的明細，您可點選該列資料，即可查看案件明細。</p>
      <Img src={Direction06} />
      <SubTitle>案件明細：</SubTitle>
      <p>商標證書預覽及下載：點擊 pdf 連結，即可下載商標證書。</p>
      <TextAnnotation>附註：商標證書影像檔自公告日期2017/09/01起提供</TextAnnotation>
      <Img src={Direction07} />
    </MainContent>
  );
};

export default TmarkDirectionMobile;
